var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D8FBF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6867 17.5962C9.54493 18.4982 10.1787 19.1243 10.9548 19.4363C13.93 20.6326 18.0702 20.6326 21.0453 19.4363C21.8214 19.1243 22.4552 18.4982 22.3135 17.5962C22.2263 17.0418 21.7955 16.5802 21.4763 16.1295C21.0583 15.5318 21.0168 14.88 21.0167 14.1864C21.0167 11.5062 18.7707 9.3335 16.0001 9.3335C13.2295 9.3335 10.9835 11.5062 10.9835 14.1864C10.9834 14.88 10.9419 15.5318 10.5238 16.1295C10.2046 16.5802 9.77382 17.0418 9.6867 17.5962Z",
    stroke: "#11B989",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22C14.5308 22.4146 15.2317 22.6667 16 22.6667C16.7683 22.6667 17.4693 22.4146 18 22",
    stroke: "#11B989",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti);
export default __webpack_public_path__ + "static/media/noti.463e9e2846c5c55c58d86aabd23f4a99.svg";
export { ForwardRef as ReactComponent };